import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_react-dom@19.1.2_react@19.1.2__react@19.1.2/node_modules/next/dist/client/app-dir/link.js");
